import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { portalActions } from '../../store';
import { selectLanguage } from '../../store/languageSlice';
import { getTValue } from '../../translations/common';
import { ContactUsSerivce } from '../../utilFunctions/contactUs';
import Loader from '../UI/Loader';
import './style.css';

import { userProfileDetailReq } from '../../utilFunctions/profile/EditProfile';

import useFetchData from '../../utilFunctions/useFetchData';

export default function ContactUs() {
  const dispatch = useDispatch();
  const { t, isRtl } = useSelector(selectLanguage);
  const PHONE_CODE = '+966';
  const [titleRequire, setTitleRequire] = useState(false);
  const [messageRequire, setMessageRequire] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState();
  const [error, setError] = useState(false);

  const {
    data: profileData,
    loading: profileLoading,
    error: profileError,
    refetch: refetchProfile,
  } = useFetchData(userProfileDetailReq);

  const [formData, setFormData] = useState({
    email: '',
    phone: '',
    name: '',
    title: '',
    message: '',
  });

  const isVerified =
  profileData?.patientProfile?.isEmailVerified === '1';

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'message' && value.length > 500) {
      return;
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    titleRequire && setTitleRequire(false);
    messageRequire && setMessageRequire(false);
  };

  const handleContactUsReport = async (event) => {
    event.preventDefault();
    
    const isTitleInvalid = !formData?.title?.trim();
    const isMessageInvalid = !formData?.message?.trim();

    setTitleRequire(isTitleInvalid);
    setMessageRequire(isMessageInvalid);

    if (isTitleInvalid || isMessageInvalid) {
      return;
    }

    setMessage();
    setError(false);
    setLoading(true);
    const responseData = await ContactUsSerivce(formData);
    // dispatch(portalActions.toggleContactUsDrawer());

    setLoading(false);
    if (responseData?.status == 'Success') {
      setMessage(t.FormSubmitted);
      // setTimeout(() => {
      //   dispatch(portalActions.toggleContactUsDrawer());
      // }, 2000);
    } else {
      setError(true);
      setMessage(t.FormFailed);
    }
  };

  useEffect(()=>{
    if(message){
      setFormData((prev) => ({
        ...prev,
        title: '',
        message: '',
      }));
      setTimeout(()=>setMessage(), 3000)
    }
  },[message])

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    if (userInfo) {
      const firstName = getTValue(userInfo, 'arabic_first_name', 'firstName');
      const lastName = getTValue(userInfo, 'arabic_last_name', 'lastName');

      setFormData({
        ...formData,
        email: userInfo?.email || '',
        phone: userInfo?.mobileNumber || '',
        mrNumber: userInfo?.mrn || '',
        name: `${firstName} ${lastName}` || '',
      });
    }
  }, []);

  if (profileLoading) return <Loader />;
  
  if (profileError) {
    return <div className="p-8">{t.Something_Wrong}</div>;
  }

  return (
    <div>
      <div className="px-8">
        <form onSubmit={handleContactUsReport}>
          {!message && (
          <>
          <label htmlFor="name">
            {t.Name} <br />
            <input
              id="name"
              type="text"
              name="name"
              defaultValue={formData?.name}
              onChange={handleChange}
              disabled
              className='disabled'
            />
          </label>
          <label htmlFor="email">
            {t.EmailAddress} <br />
            <input
              id="email"
              type="email"
              name="email"
              defaultValue={formData?.email}
              onChange={handleChange}
              disabled
              className='disabled'
            />
            
            {!isVerified && 
              <p className="text-tertiary mt-1">
                {t.EmailNotVerified}
              </p>
            }
          </label>
          <label htmlFor="phone">
            {t.CellPhoneNumber}
            <br />
            <div className="countrycode" dir="ltr">
              <div className="code text-secondary">({PHONE_CODE})</div>
              <input
                id="phone"
                type="number"
                name="phone"
                placeholder="5xxxxxxxx"
                defaultValue={formData?.phone}
                onChange={handleChange}
                disabled
                className='disabled noArrow'
              />
            </div>
          </label>
          <label htmlFor="title">
            {t.Title}* <br />
            <input
              id="title"
              type="text"
              name="title"
              defaultValue={formData?.title}
              onChange={handleChange}
            />
            {titleRequire && (
              <label className="text-tertiary mt-1">{t.FieldIsRequired}</label>
            )}
          </label>
          <label htmlFor="message">
            {t.Message}* <br />
            <textarea
              id="message"
              name="message"
              placeholder={t.TypeMessage}
              defaultValue={formData?.message}
              onChange={handleChange}
              maxLength={500}
            ></textarea>

            <p className=" text-gray-500 mt-1">{formData.message.length}/500</p>

            {messageRequire && (
              <label className="text-tertiary mt-1">{t.MessageFieldRequired}</label>
            )}
          </label>
          <div className="flex justify-center mt-3">
            <button type="submit" className={`request_btn ${!isVerified && 'opacity-[0.5] cursor-not-allowed'}`} disabled={!isVerified}>
              {loading ? <Loader size="small" roundLoader /> : t.send}
            </button>
          </div>
          </>)}
          {message && (
            <p className={`${error ? 'errorMsg' : 'successMsg'} my-2 text-center`}>
              <span>{message}</span>
            </p>
          )}
        </form>
      </div>
    </div>
  );
}
